import {
  Component,
  ViewChild,
  OnInit,
  ElementRef,
  OnDestroy,
  AfterViewInit,
  Input,
  SimpleChanges,
  OnChanges,
  OutputEmitterRef,
  output,
} from "@angular/core";
import {
  FormBuilder,
  FormArray,
  FormGroup,
  Validators,
  ValidatorFn,
  AbstractControl,
  ValidationErrors,
} from "@angular/forms";
import { DashboardService } from "../dashboard.service";
import { ModalService } from "../modal.service";
import { ActivatedRoute, Router } from "@angular/router";
import { DataStoreServiceService } from "../data-store-service.service";
import { merge, Observable, Subscription } from "rxjs";
import { TranslateService } from "@ngx-translate/core";
import { SharedService } from "src/app/shared/shared.service";
import { HttpErrorResponse } from "@angular/common/http";
import { AttachmentPopupComponent } from "../attachment-popup/attachment-popup.component";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { CredentialsService } from "src/app/core/credentials.service";
import { filter, map, retry, startWith, takeUntil, tap } from "rxjs/operators";
import { MatMenuTrigger } from "@angular/material/menu";
import { ConfirmEmConsultationComponent } from "../confirm-em-consultation/confirm-em-consultation.component";
import { CleverTapService } from "src/app/clevertap.service";
import { ConsultationDetails } from "../consults-page/consults-page.component";

export interface ChiefComplaintList {
  _id: string;
  isOther: boolean;
  status: number;
  chiefComplaint: ChiefComplaint;
  createdAt: Date;
  updatedAt: Date;
}

export interface ChiefComplaint {
  en: string;
  es: string;
}

export interface RouteOfAdministration {
  _id: string;
  status: number;
  routeOfAdministration: RouteOfAdministrationClass;
  createdAt: Date;
  updatedAt: Date;
}

export interface RouteOfAdministrationClass {
  en: string;
  es: string;
}

export interface MoreConsultationDetails {
  data: Datum[];
  meta: Meta;
}

export interface Datum {
  _id: string;
  chiefComplaint: ChiefComplaint;
  document: any[];
  informedConsent: boolean;
  patient: Patient;
  parent: Parent;
  status: number;
  consultationType: number;
  appointmentType: number;
  appointmentStatus: number;
  appointmentRescheduledCount: number;
  appointmentRescheduledByDoctorCount: number;
  action: string[];
  paraclinicalPrescription: Array<any[] | null>;
  medicalPrescription?: Array<MedicalPrescription | null>;
  providerCall: string;
  createdAt: Date;
  updatedAt: Date;
  communicationMode: number;
  date: Date;
  provider: string;
  utcOffset: number;
  doctor: DatumDoctor;
  hour: string;
  followUpDate: Date;
  hasFollowUp: boolean;
  visitForm: VisitForm;
  consultationTime: number;
  waitingTime: number;
  followUpConsultation: FollowUpConsultation;
  originCall: number;
  followUpConsultation2: FollowUpConsultation;
}
export interface MedicalPrescription {
  durationTime?: DurationTime;
  frequencyTime?: any;
  routeOfAdministration?: RouteOfAdministration;
  unit?: Unit;
  alternative?: Array<Alternative | null>;
}
export interface DurationTime {
  id: any;
}
export interface FrecuencyTime {
  id: string;
}
export interface RouteOfAdministration {
  id: any;
}
export interface Unit {
  id: any;
}
export interface Alternative {
  durationTime?: DurationTime;
  frequencyTime?: any;
  routeOfAdministration?: RouteOfAdministration;
  unit?: Unit;
}

export interface ChiefComplaint {
  id: string;
  chiefComplaint: SpecialityClass;
}

export interface SpecialityClass {
  en: string;
  es: string;
}

export interface DatumDoctor {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
  speciality: PurpleSpeciality[];
  subSpeciality: SubSpeciality[];
  cmNumber: string;
  countryCode: string;
  identificationNumber: string;
  mppsNumber: string;
  phoneNumber: string;
  profilePic: string;
}

export interface PurpleSpeciality {
  id: string;
  speciality: SpecialityClass;
  other?: string;
}

export interface SubSpeciality {
  id: string;
  subSpeciality: SpecialityClass;
}

export interface FollowUpConsultation {
  _id: string;
  document: any[];
  status: number;
  consultationType: number;
  appointmentType: number;
  appointmentStatus: number;
  appointmentRescheduledCount: number;
  appointmentRescheduledByDoctorCount: number;
  action: string[];
  paraclinicalPrescription: any[];
  medicalPrescription?: any[]; //medicalPrescription
  originCall?: number;
  parent: string;
  patient: string;
  providerCall: string;
  chiefComplaint: ChiefComplaint;
  communicationMode: number;
  date: Date;
  isFollowUp: boolean;
  parentConsultation: string;
  provider: string;
  createdAt: Date;
  updatedAt: Date;
  doctor: FollowUpConsultationDoctor;
  hour: string;
  followUpForm: any;
}

export interface FollowUpConsultationDoctor {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
  cmNumber: string;
  countryCode: string;
  identificationNumber: string;
  mppsNumber: string;
  phoneNumber: string;
  speciality: FluffySpeciality[];
  subSpeciality: SubSpeciality[];
}

export interface FluffySpeciality {
  id: string;
  speciality: SpecialityClass;
}

export interface Parent {
  _id: string;
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  identificationNumber: string;
  countryCode: string;
  profilePic: string;
}

export interface Patient {
  _id: string;
  firstName: string;
  lastName: string;
  profilePic: string;
  identificationNumber: string;
}

export interface VisitForm {
  _id: string;
  consultation: string;
  patient: string;
  parent: string;
  doctor: string;
  status: number;
  historyOfPresentIllness: string;
  paraclinics: string;
  plan: string;
  doctorNotes: string;
  createdAt: Date;
  updatedAt: Date;
  reviewOfSystem?: any;
  differentialDiagnosisCie11?: any[];
  diagnosisCie11?: any[];
  heartRate?: string;
  respiratoryRate?: string;
  temperature?: string;
  bloodPressureSystolic?: string;
  bloodPressureDiastolic?: string;
}

export interface Meta {
  fileUrl: string;
  videoRecordingFileUrl: string;
}

@Component({
  selector: "app-new-visit-summary",
  templateUrl: "./new-visit-summary.component.html",
  styleUrls: ["./new-visit-summary.component.scss"],
})
export class NewVisitSummaryComponent implements OnInit, OnDestroy, AfterViewInit, OnChanges
{
  @ViewChild("submitBtn") submitBtn: ElementRef;
  @ViewChild("trigger") trigger: MatMenuTrigger;
  @ViewChild("trigger2") trigger2: MatMenuTrigger;
  @Input() followCallingUp: boolean;
  @Input() normalConsult: boolean;
  transfer: boolean = false;

  scrollIntoView: OutputEmitterRef<string> = output();

  chiefComplaintList: Array<ChiefComplaintList> = [];
  Units: Array<any> = [];
  bodysystem: Array<any> = [];
  adminstrations: Array<any> = [];
  tablete: Array<any> = [];
  consultId: string;
  public currentVisitDetails: any = {
    document: [],
  };
  public singPatientRecord: any;
  loading: boolean = true;
  visitSummary: boolean = false;
  isTestCall: boolean = false;
  istestingCallingUp: any;
  vsSubmitSubscription: Subscription;
  followUpInfo: any;
  vscallStatusSubscription: Subscription;
  currentLanguage: string = this.translateService.currentLang == "en-US" ? "en" : "es";
  isPlanValid = true;
  isDiagnosisValid = true;
  isPresentIllnessValid = true;
  closureReasons: Array<any> = [];
  isOtherClosureReason: boolean = false;
  closeAttentionForm = this.fb.group({
    closeAttention: [false, [Validators.required]],
    closureReason: [""],
    otherClosureReason: [""],
  });

  diagnosticList: Array<any> = [];
  diagnosticListFiltered: Array<any> = [];
  differentialDiagnosisListFiltered: Array<any> = [];

  diagnosticListSelected: Array<any> = [];
  differentialDiagnosisListSelected: Array<any> = [];

  assessmentListSelected: Array<any> = [];
  assessmentListFiltered: Array<any> = [];
  assessmentValue: "";

  nonWhitespaceRegExp: RegExp = new RegExp("(?<=<div>)([wds]*?)(?=</div>)");

  filteredOptions: Observable<string[]>;
  private readonly subscriptions: Subscription = new Subscription();

  dialogRef: MatDialogRef<any>;

  //Mediktor
  showMediktorSection = false;
  compatibleDiagnosticMediktor = false;

  form = this.fb.group({
    chiefComplaint: ["", [Validators.required]],
    otherChiefComplaint: [""],
    historyOfPresentIllness: ["", [Validators.required, this.noEmptyHTML()]],
    heartRate: [""],
    respiratoryRate: [""],
    temperature: ["", Validators.pattern(/^\d{0,3}(\.\d{0,2})?$/)],
    bloodPressureSystolic: [""],
    bloodPressureDiastolic: [""],
    paraclinics: [""],
    //differentialDiagnosis: [""],
    differentialDiagnosisCie11: [""],
    //diagnosis: ["", [Validators.required]],
    diagnosisCie11: [""],
    plan: ["", [Validators.required, this.noEmptyHTML()]],
    doctorNotes: [""],
    paraclinicalPrescription: this.fb.array([
      this.initParaClinicalPrescription(),
    ]),
    reviewOfSystem: this.fb.array([this.initReviewOfSystem()]),
    medicalPrescription: this.fb.array([this.initX()]),
    followUpForm: this.fb.group({
      subjective: [""],
      objective: [""],
      plan: [""],
      assesment: [""],
      closeAttentionForm: this.closeAttentionForm,
    }),
    mpFollowUpForm1: this.fb.group({
      subjective: [""],
      objective: [""],
      plan: [""],
      assesment: [""],
    }),
    mpFollowUpForm2: this.fb.group({
      subjective: [""],
      objective: [""],
      plan: [""],
      assesment: [""],
    }),
    closeAttentionForm: this.closeAttentionForm,
  });

  mpFollowUpForm = this.fb.group({
    medicalPrescription: this.fb.array([this.initX()]),
  });

  mpFollowUpForm1 = this.fb.group({
    medicalPrescription: this.fb.array([this.initX()]),
  });

  mpFollowUpForm2 = this.fb.group({
    medicalPrescription: this.fb.array([this.initX()]),
  });

  formControlPlaceholder = "";

  showOtherChiefComplaint: boolean = false;
  historyOfPresentIllness = "";

  isOriginalDoctor = true;
  isFollowUpEditEnabled = false;
  isRegularFormEnabled = false;
  reviewOfSystemSubscription$: Subscription;

  noEmptyHTML(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const valueWithoutHtmlTags = (control.value ?? "").replace(
        /<[^>]+>/g,
        "",
      );
      const valueWithoutTagsAndSpace = valueWithoutHtmlTags.replace(
        /&nbsp;/g,
        "",
      );

      const result =
        valueWithoutTagsAndSpace == "" ||
        new RegExp(/^\s*$/).test(valueWithoutTagsAndSpace);

      return result ? { notEmptyText: { value: control.value } } : null;
    };
  }

  setHistoryOfPresentIllness(val: any) {
    const valueWithoutHtmlTags = val.replace(/<[^>]+>/g, "");
    const valueWithoutTagsAndSpace = valueWithoutHtmlTags.replace(
      /&nbsp;/g,
      "",
    );

    if (
      valueWithoutTagsAndSpace == "" ||
      new RegExp(/^\s*$/).test(valueWithoutTagsAndSpace)
    ) {
      this.isPresentIllnessValid = false;
    } else {
      this.isPresentIllnessValid = true;
    }

    if (!(val instanceof Event)) {
      this.form.patchValue({ historyOfPresentIllness: val });
    }
  }

  paraclinics = "";
  setParaclinics(val: any) {
    if (!(val instanceof Event))
      this.form.patchValue({
        paraclinics: val,
      });
  }

  differentialDiagnosisCie11 = "";
  setDifferentialDiagnosis(val: any) {
    if (!(val instanceof Event))
      this.form.patchValue({ differentialDiagnosisCie11: val });
  }

  diagnosisCie11 = "";
  setDiagnosis(val: any) {
    const valueWithoutHtmlTags = val.replace(/<[^>]+>/g, "");
    const valueWithoutTagsAndSpace = valueWithoutHtmlTags.replace(
      /&nbsp;/g,
      "",
    );

    if (
      valueWithoutTagsAndSpace == "" ||
      new RegExp(/^\s*$/).test(valueWithoutTagsAndSpace)
    ) {
      this.isDiagnosisValid = false;
    } else {
      this.isDiagnosisValid = true;
    }
    if (!(val instanceof Event)) this.form.patchValue({ diagnosisCie11: val });
  }

  plan = "";
  setPlan(val: any) {
    const valueWithoutHtmlTags = val.replace(/<[^>]+>/g, "");
    const valueWithoutTagsAndSpace = valueWithoutHtmlTags.replace(
      /&nbsp;/g,
      "",
    );

    if (
      valueWithoutTagsAndSpace == "" ||
      new RegExp(/^\s*$/).test(valueWithoutTagsAndSpace)
    ) {
      this.isPlanValid = false;
    } else {
      this.isPlanValid = true;
    }

    if (!(val instanceof Event)) this.form.patchValue({ plan: val });
  }

  doctorNotes = "";
  setDoctorNotes(val: any) {
    if (!(val instanceof Event)) this.form.patchValue({ doctorNotes: val });
  }

  followUpCall = {
    subjective: "",
    objective: "",
    assesment: "",
    assesmentCie11: [],
    plan: "",
  };

  haveFollowUp1 = false;
  previousFollowUp1 = {
    subjective: "",
    objective: "",
    assesment: "",
    assesmentCie11: [],
    plan: "",
  };

  haveFollowUp2 = false;
  previousFollowUp2 = {
    subjective: "",
    objective: "",
    assesment: "",
    assesmentCie11: [],
    plan: "",
  };

  updateFollowUp(forWhich: string, val: any) {
    this.form.patchValue({
      followUpForm: {
        [forWhich]: val,
      },
    });
  }

  private _dosageAndUnitSubcription = Subscription.EMPTY;

  constructor(
    private fb: FormBuilder,
    private dashboardService: DashboardService,
    private modalService: ModalService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private store: DataStoreServiceService,
    private translateService: TranslateService,
    public dialog: MatDialog,
    private sharedService: SharedService,
    private credentialService: CredentialsService,
    private readonly clevertap: CleverTapService,
  ) {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.consultId = params.id;
    });

    this.store
      .getPatientRecord()
      .pipe(filter((record) => !!record))
      .subscribe((newName) => {
        this.singPatientRecord = newName;

        this.loading = false;

        if (this.singPatientRecord?.consultation?.status === 4) {
          this.visitSummary = true;

          if (this.singPatientRecord?.consultation?.isFollowUp) {
            this.getVisitDetails(
              this.singPatientRecord.consultation.parentConsultation,
            );
          }
        } else {
          this.visitSummary = false;
        }
      });

    this.dashboardService.getConsultationDetails(this.consultId).subscribe({
      next: (res: ConsultationDetails) => {
        const [consultationDetails] = res.data;

        this.currentVisitDetails = consultationDetails;
        this.getCheifComplaintsList();
      },
      error: (error: HttpErrorResponse) => {
        this.handleError(error);
      },
    });

    this.getUnits();
    this.getRouteofAdmininstration();
    this.getTablete();
    this.getBodySystem();
    this.getClosureReasons();
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.chiefComplaintList
      .map((chiefComplaint) => chiefComplaint.chiefComplaint.es)
      .filter((option) => option.toLowerCase().includes(filterValue));
  }

  ngOnInit() {
    this.filteredOptions = this.form.controls[
      "chiefComplaint"
    ].valueChanges.pipe(
      startWith(""),
      map((value) => this._filter(this.form.get("chiefComplaint").value)),
    );

    this.form
    .get("paraclinicalPrescription")
    .valueChanges.subscribe((data) => this.validatePcp());
    this.validatePcp();

    this.reviewOfSystemSubscription$ = this.form
    .get("reviewOfSystem")
    .valueChanges.subscribe((data) => this.validateReviewOfSystem());

    this.validateReviewOfSystem();

    
    this.subscriptions.add(
      this.modalService.vscallStatusObservable.subscribe({
        next: (res) => {
          if (res.callStarted == true) {
            this.visitSummary = true;
            if (this.singPatientRecord?.consultation?.isFollowUp == true) {
              this.getVisitDetails(
                this.singPatientRecord.consultation.parentConsultation,
              );
            }
          }
        },
        error: (err) => console.log("error", err),
      })
    );

    this.subscriptions.add(
      this.modalService.vsSubmitObservable.subscribe({
        next:(res) => {
            this.followUpInfo = res;
            this.transfer = res.transfer;
          
            if ( this.isTestCall == true ) {
              const data = {
                isTestCall: this.isTestCall,
                hasFollowUp: res.hasFollowUp,
                followUpDate: res.followUpDate,
              };
              this.openConfirmEmDialog(this.consultId, data);
            } 
            else {
              this.form.markAllAsTouched();
              this.form.markAsDirty();
              this.formSubmit();
              
            }
          },
          error: (err) => console.log("error", err),
      }),
    );
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.enableUpdateBtn();
    }, 1000);
  }

  ngOnChanges(changes: SimpleChanges) {

    if (changes?.followCallingUp?.currentValue) {
      const closeAttentionForm: FormGroup = this.form.get(
        "closeAttentionForm",
      ) as FormGroup;

      closeAttentionForm.get("closeAttention").setValue(false);
      closeAttentionForm.get("closureReason").setErrors(null);
      closeAttentionForm.get("otherClosureReason").setErrors(null);

      this.closeAttentionChange({ checked: false });
    }
  }

  getNameUpdate(event?, index?, forFollowUp?) {
    this._dosageAndUnitSubcription.unsubscribe();
    const value = event.target.value;

    let XsA = forFollowUp
      ? <FormArray>this.mpFollowUpForm["controls"].medicalPrescription
      : <FormArray>this.form["controls"].medicalPrescription;

    if (value.length) {
      XsA.at(index).enable();

      [
        "frequency",
        "frequencyTime",
        "duration",
        "dosage",
        "durationTime",
        "unit",
        "routeOfAdministration",
      ].forEach((control) => {
        if (control === "frequency") {
          XsA.at(index)
            .get(control)
            .setValidators([
              Validators.required,
              Validators.pattern(/^[1-9]\d{0,2}(?:\,\d{1,3})?$/),
            ]);
        } else {
          XsA.at(index).get(control).setValidators([Validators.required]);
        }
        XsA.at(index).get(control).enable({ emitEvent: false });
        XsA.at(index).get(control).markAsDirty();
        XsA.at(index).get(control).markAsTouched();
        XsA.at(index).get(control).updateValueAndValidity();
      });

      let resetFields = false; // updateValueAndValidity fires a change event, this prevents looping through the observable.

      // this._dosageAndUnitSubcription = merge(
      //   // XsA.at(index).get("dosage").valueChanges,
      //   XsA.at(index).get("unit").valueChanges,
      // ).subscribe((value) => {
      //   if (value) {
      //     // XsA.at(index).get("dosage").setValidators([Validators.required]);
      //     // XsA.at(index).get("dosage").enable({ emitEvent: false });

      //     XsA.at(index).get("dosage").setValidators([Validators.required]);
      //     XsA.at(index).get("unit").setValidators([Validators.required]);

      //     if (!this.singPatientRecord?.consultation?.isFollowUp) {
      //       XsA.at(index).get("dosage").enable({ emitEvent: false });
      //       XsA.at(index).get("unit").enable({ emitEvent: false });
      //     }

      //     resetFields = false;
      //   } else {
      //     if (!resetFields) {
      //       resetFields = true;
      //       XsA.at(index).get("unit").setValidators([]);
      //       // XsA.at(index).get("dosage").setValidators([]);
      //       XsA.at(index).get("unit").updateValueAndValidity();
      //       // XsA.at(index).get("dosage").updateValueAndValidity();
      //     }
      //   }
      // });
    } else {
      XsA.at(index).disable();
      XsA.at(index).get("name").enable();
    }
  }

  getAlternateNameUpdate(event, index, alterIndex, forFollowUp) {
    const value = event.target.value;
    let XsA = forFollowUp
      ? <FormArray>this.mpFollowUpForm["controls"].medicalPrescription
      : <FormArray>this.form["controls"].medicalPrescription;
    let alternate = <FormArray>XsA.at(index).get("alternative");
    const currentItem = alternate.at(alterIndex);
    if (currentItem) {
      if (value.length > 0) {
        currentItem.enable();
        currentItem.get("frequency").setValidators([Validators.required]);
        currentItem.get("frequency").updateValueAndValidity();
        currentItem.get("frequency").enable();
        currentItem.get("frequencyTime").setValidators([Validators.required]);
        currentItem.get("frequencyTime").updateValueAndValidity();
        currentItem.get("frequencyTime").enable();
        currentItem.get("duration").setValidators([Validators.required]);
        currentItem.get("duration").updateValueAndValidity();
        currentItem.get("duration").enable();
        currentItem.get("durationTime").setValidators([Validators.required]);
        currentItem.get("durationTime").updateValueAndValidity();
        currentItem.get("durationTime").enable();
      } else {
        currentItem.disable();
        currentItem.get("name").enable();
      }
    }
  }

  getVisitDetails(parentId: string) {
    this.dashboardService.getConsultationDetails(parentId).subscribe({
      next: (res: MoreConsultationDetails) => {
        const [data] = res.data;

        if (
          this.credentialService.credentials.userDetails._id === data.doctor._id
        ) {
          this.isOriginalDoctor = true;
        } else {
          this.isOriginalDoctor = false;
        }

        this.mpFollowUpForm1.disable();
        if (data.followUpConsultation?.followUpForm) {
          this.haveFollowUp1 = true;
          this.previousFollowUp1.assesmentCie11 = data.followUpConsultation
            .followUpForm.assesmentCie11
            ? data.followUpConsultation.followUpForm.assesmentCie11
            : [];
          this.previousFollowUp1.subjective =
            data.followUpConsultation.followUpForm.subjective;
          this.previousFollowUp1.objective =
            data.followUpConsultation.followUpForm.objective;
          this.previousFollowUp1.assesment =
            data.followUpConsultation.followUpForm.assesment;
          this.previousFollowUp1.plan =
            data.followUpConsultation.followUpForm.plan;

          if (data.followUpConsultation.medicalPrescription?.length) {
            for (
              var j = 0;
              j < data.followUpConsultation.medicalPrescription.length;
              j++
            ) {
              data.followUpConsultation.medicalPrescription[j].durationTime =
                data.followUpConsultation.medicalPrescription[
                  j
                ].durationTime.id;
              data.followUpConsultation.medicalPrescription[j].frequencyTime =
                data.followUpConsultation.medicalPrescription[
                  j
                ].frequencyTime.id;
              data.followUpConsultation.medicalPrescription[
                j
              ].routeOfAdministration = data.followUpConsultation
                .medicalPrescription[j].routeOfAdministration
                ? data.followUpConsultation.medicalPrescription[j]
                    .routeOfAdministration.id
                : "";
              data.followUpConsultation.medicalPrescription[j].unit = data
                .followUpConsultation.medicalPrescription[j].unit
                ? data.followUpConsultation.medicalPrescription[j].unit.id
                : "";
              for (
                var k = 0;
                k <
                data.followUpConsultation.medicalPrescription[j].alternative
                  .length;
                k++
              ) {
                data.followUpConsultation.medicalPrescription[j].alternative[
                  k
                ].durationTime =
                  data.followUpConsultation.medicalPrescription[j].alternative[
                    k
                  ].durationTime.id;
                data.followUpConsultation.medicalPrescription[j].alternative[
                  k
                ].frequencyTime =
                  data.followUpConsultation.medicalPrescription[j].alternative[
                    k
                  ].frequencyTime.id;
                data.followUpConsultation.medicalPrescription[j].alternative[
                  k
                ].routeOfAdministration = data.followUpConsultation
                  .medicalPrescription[j].alternative[k].routeOfAdministration
                  ? data.followUpConsultation.medicalPrescription[j]
                      .alternative[k].routeOfAdministration.id
                  : "";
                data.followUpConsultation.medicalPrescription[j].alternative[
                  k
                ].unit = data.followUpConsultation.medicalPrescription[j]
                  .alternative[k].unit
                  ? data.followUpConsultation.medicalPrescription[j]
                      .alternative[k].unit.id
                  : "";
              }
            }

            this.setExistMedicalPrescription(
              data.followUpConsultation.medicalPrescription,
              this.mpFollowUpForm1,
            );
          }
        }

        this.mpFollowUpForm2.disable();
        if (data.followUpConsultation2?.followUpForm) {
          this.haveFollowUp2 = true;
          this.previousFollowUp2.assesmentCie11 = data.followUpConsultation2
            .followUpForm.assesmentCie11
            ? data.followUpConsultation2.followUpForm.assesmentCie11
            : [];
          this.previousFollowUp2.subjective =
            data.followUpConsultation2.followUpForm.subjective;
          this.previousFollowUp2.objective =
            data.followUpConsultation2.followUpForm.objective;
          this.previousFollowUp2.assesment =
            data.followUpConsultation2.followUpForm.assesment;
          this.previousFollowUp2.plan =
            data.followUpConsultation2.followUpForm.plan;

          if (data.followUpConsultation2?.medicalPrescription?.length) {
            for (
              var j = 0;
              j < data.followUpConsultation2.medicalPrescription.length;
              j++
            ) {
              data.followUpConsultation2.medicalPrescription[j].durationTime =
                data.followUpConsultation2.medicalPrescription[
                  j
                ].durationTime.id;
              data.followUpConsultation2.medicalPrescription[j].frequencyTime =
                data.followUpConsultation2.medicalPrescription[
                  j
                ].frequencyTime.id;
              data.followUpConsultation2.medicalPrescription[
                j
              ].routeOfAdministration = data.followUpConsultation2
                .medicalPrescription[j].routeOfAdministration
                ? data.followUpConsultation2.medicalPrescription[j]
                    .routeOfAdministration.id
                : "";
              data.followUpConsultation2.medicalPrescription[j].unit = data
                .followUpConsultation2.medicalPrescription[j].unit
                ? data.followUpConsultation2.medicalPrescription[j].unit.id
                : "";
              for (
                var k = 0;
                k <
                data.followUpConsultation2.medicalPrescription[j].alternative
                  .length;
                k++
              ) {
                data.followUpConsultation2.medicalPrescription[j].alternative[
                  k
                ].durationTime =
                  data.followUpConsultation2.medicalPrescription[j].alternative[
                    k
                  ].durationTime.id;
                data.followUpConsultation2.medicalPrescription[j].alternative[
                  k
                ].frequencyTime =
                  data.followUpConsultation2.medicalPrescription[j].alternative[
                    k
                  ].frequencyTime.id;
                data.followUpConsultation2.medicalPrescription[j].alternative[
                  k
                ].routeOfAdministration = data.followUpConsultation2
                  .medicalPrescription[j].alternative[k].routeOfAdministration
                  ? data.followUpConsultation2.medicalPrescription[j]
                      .alternative[k].routeOfAdministration.id
                  : "";
                data.followUpConsultation2.medicalPrescription[j].alternative[
                  k
                ].unit = data.followUpConsultation2.medicalPrescription[j]
                  .alternative[k].unit
                  ? data.followUpConsultation2.medicalPrescription[j]
                      .alternative[k].unit.id
                  : "";
              }
            }

            this.setExistMedicalPrescription(
              data.followUpConsultation2.medicalPrescription,
              this.mpFollowUpForm2,
            );
          }
        }

        if (data.visitForm?.reviewOfSystem?.length) {
          for (var i = 0; i < data.visitForm.reviewOfSystem.length; i++) {
            data.visitForm.reviewOfSystem[i].bodySystem =
              data.visitForm.reviewOfSystem[i].id;
          }
        }

        if (data.medicalPrescription?.length) {
          const hasNullValues = (currentValue) =>
            [null, undefined].includes(currentValue);

          if (data.medicalPrescription.every(hasNullValues)) {
            data.medicalPrescription = [];
          } else {
            for (var j = 0; j < data.medicalPrescription.length; j++) {
              data.medicalPrescription[j].durationTime =
                data.medicalPrescription[j].durationTime.id;
              data.medicalPrescription[j].frequencyTime =
                data.medicalPrescription[j].frequencyTime.id;
              data.medicalPrescription[j].routeOfAdministration = data
                .medicalPrescription[j].routeOfAdministration
                ? data.medicalPrescription[j].routeOfAdministration.id
                : "";
              data.medicalPrescription[j].unit = data.medicalPrescription[j]
                .unit
                ? data.medicalPrescription[j].unit.id
                : "";
              for (
                var k = 0;
                k < data.medicalPrescription[j].alternative.length;
                k++
              ) {
                data.medicalPrescription[j].alternative[k].durationTime =
                  data.medicalPrescription[j].alternative[k].durationTime.id;
                data.medicalPrescription[j].alternative[k].frequencyTime =
                  data.medicalPrescription[j].alternative[k].frequencyTime.id;
                data.medicalPrescription[j].alternative[
                  k
                ].routeOfAdministration = data.medicalPrescription[j]
                  .alternative[k].routeOfAdministration
                  ? data.medicalPrescription[j].alternative[k]
                      .routeOfAdministration.id
                  : "";
                data.medicalPrescription[j].alternative[k].unit = data
                  .medicalPrescription[j].alternative[k].unit
                  ? data.medicalPrescription[j].alternative[k].unit.id
                  : "";
              }
            }
          }
        }

        this.historyOfPresentIllness = data.visitForm.historyOfPresentIllness;
        this.paraclinics = data.visitForm.paraclinics;
        this.differentialDiagnosisCie11 = "";
        this.diagnosisCie11 = "";
        this.plan = data.visitForm.plan;
        this.doctorNotes = data.visitForm.doctorNotes;

        if (data.visitForm.differentialDiagnosisCie11.length) {
          this.differentialDiagnosisListSelected =
            data.visitForm.differentialDiagnosisCie11;
        }

        if (data.visitForm.diagnosisCie11.length) {
          this.diagnosticListSelected = data.visitForm.diagnosisCie11;
        }

        this.form.patchValue({
          historyOfPresentIllness: data.visitForm.historyOfPresentIllness,
          heartRate: data.visitForm.heartRate,
          respiratoryRate: data.visitForm.respiratoryRate,
          temperature: data.visitForm.temperature,
          bloodPressureSystolic: data.visitForm.bloodPressureSystolic,
          bloodPressureDiastolic: data.visitForm.bloodPressureDiastolic,
          paraclinics: data.visitForm.paraclinics,
          /*     differentialDiagnosisCie11: data.visitForm.differentialDiagnosisCie11,
          diagnosisCie11: data.visitForm.diagnosisCie11, */
          plan: data.visitForm.plan,
          doctorNotes: data.visitForm.doctorNotes,
        });

        if (data.medicalPrescription?.length) {
          this.setExistMedicalPrescription(data.medicalPrescription, null);
        }

        if (data.visitForm.reviewOfSystem?.length) {
          this.form.setControl(
            "reviewOfSystem",
            this.setExistReviewSystem(data.visitForm.reviewOfSystem),
          );

          this.reviewOfSystemSubscription$.unsubscribe();
          this.reviewOfSystemSubscription$ = this.form
            .get("reviewOfSystem")
            .valueChanges.subscribe((data) => {
              return this.validateReviewOfSystem();
            });

          for (let subControl of (this.form.get("reviewOfSystem") as FormArray)
            .controls) {
            subControl.disable();
          }
        }

        if (data.paraclinicalPrescription?.length) {
          this.form.setControl(
            "paraclinicalPrescription",
            this.setExistParaclinicalPrescription(
              data.paraclinicalPrescription,
            ),
          );
          for (let subControl of (
            this.form.get("paraclinicalPrescription") as FormArray
          ).controls) {
            subControl.disable();
          }
        }

        setTimeout(() => {
          this.enableUpdateBtn();
        }, 1000);
      },
      error: (error: HttpErrorResponse) => {
        this.handleError(error);
      },
    });
  }

  // updateHistoryOfPresentIllness() {}

  setExistParaclinicalPrescription(list: any[]): FormArray {
    const epp = new FormArray([]);
    list.forEach((s) => {
      let newGroup = this.fb.group({
        _id: s._id,
        title: s.title,
        description: s.description,
      });
      epp.push(newGroup);
    });
    return epp;
  }

  setExistReviewSystem(list: any[]): FormArray {
    const fa = new FormArray([]);
    list.forEach((s) => {
      let newGroup = this.fb.group({
        bodySystem: s.id,
        value: s.value,
      });
      fa.push(newGroup);
    });
    return fa;
  }

  setExistMedicalPrescription(list: any, form) {
    ((form ?? this.form).get("medicalPrescription") as FormArray).clear();
    list.forEach((t) => {
      let mp: FormGroup = this.fb.group({
        _id: [""],
        name: [""],
        dosage: [""],
        unit: [""],
        routeOfAdministration: [""],
        frequency: [""],
        frequencyTime: [""],
        duration: [""],
        durationTime: [""],
        notes: [""],
        alternative: this.fb.array([]),
      });
      mp.disable();
      ((form ?? this.form).get("medicalPrescription") as FormArray).push(mp);

      t.alternative.forEach((b) => {
        var alter = this.fb.group({
          _id: [""],
          name: [""],
          dosage: [""],
          unit: [""],
          routeOfAdministration: [""],
          frequency: [""],
          frequencyTime: [""],
          duration: [""],
          durationTime: [""],
          notes: [""],
        });
        alter.disable();

        (mp.get("alternative") as FormArray).push(alter);
      });
    });

    (form ?? this.form).patchValue({
      medicalPrescription: list,
    });

    if (!form) {
      let XsA = <FormArray>this.form["controls"].medicalPrescription;
      const totalMedicalPrecriptions = XsA.length;

      for (let i = 0; i < totalMedicalPrecriptions; i++) {
        this.getNameUpdate(
          {
            target: {
              value: "dummyValue", // This values is not doing anything, just a dummy value to fire the function
            },
          },
          i,
        );
      }
    }
  }

  validateReviewOfSystem() {
    {
      let RoSA = <FormArray>this.form["controls"].reviewOfSystem;
      this.formErrors.reviewOfSystem = [];
      let rr = 1;
      while (rr <= RoSA.length) {
        this.formErrors.reviewOfSystem.push({
          bodySystem: "",
          value: "",
        });
        let RR = <FormGroup>RoSA.at(rr - 1);

        if (RR.get("bodySystem").value != "") {
          if (RR.get("value").validator === null) {
            RR.get("value").setValidators([Validators.required]);
          }
        }
        if (
          RR.get("bodySystem").value == "" ||
          RR.get("bodySystem").value == null ||
          RR.get("bodySystem").value == undefined
        ) {
          if (RR.get("value").validator !== null) {
            RR.get("value").clearValidators();
            RR.get("value").updateValueAndValidity();
          }
        }

        if (RR.get("value").value.length > 0) {
          if (RR.get("bodySystem").validator === null) {
            RR.get("bodySystem").setValidators([Validators.required]);
          }
        }

        if (RR.get("value").value.length < 1) {
          if (RR.get("bodySystem").validator !== null) {
            RR.get("bodySystem").clearValidators();
            RR.get("bodySystem").updateValueAndValidity();
          }
        }

        for (let field in RR.controls) {
          let input = RR.get(field);

          if (input.invalid && input.dirty) {
            for (let error in input.errors) {
              this.formErrors.reviewOfSystem[rr - 1][field] =
                this.validationMessages.reviewOfSystem[field][error];
            }
          }
        }
        rr++;
      }
    }
  }

  validatePcp() {
    {
      let PcpA = <FormArray>this.form["controls"].paraclinicalPrescription;
      this.formErrors.paraclinicalPrescription = [];
      let pp = 1;
      while (pp <= PcpA.length) {
        this.formErrors.paraclinicalPrescription.push({
          title: "",
          description: "",
        });
        let PP = <FormGroup>PcpA.at(pp - 1);

        if (PP.get("title").value.length > 0) {
          if (PP.get("description").validator === null) {
            PP.get("description").setValidators([Validators.required]);
          }
        }
        if (PP.get("title").value.length < 1) {
          if (PP.get("description").validator !== null) {
            PP.get("description").clearValidators();
            PP.get("description").updateValueAndValidity();
          }
        }

        if (PP.get("description").value.length > 0) {
          if (PP.get("title").validator === null) {
            PP.get("title").setValidators([Validators.required]);
          }
        }

        if (PP.get("description").value.length < 1) {
          if (PP.get("title").validator !== null) {
            PP.get("title").clearValidators();
            PP.get("title").updateValueAndValidity();
          }
        }

        for (let field in PP.controls) {
          let input = PP.get(field);

          if (input.invalid && input.dirty) {
            for (let error in input.errors) {
              this.formErrors.paraclinicalPrescription[pp - 1][field] =
                this.validationMessages.paraclinicalPrescription[field][error];
            }
          }
        }
        pp++;
      }
    }
  }

  getBodySystem() {
    this.dashboardService.getbodySystem().subscribe(
      (res: any) => {
        this.bodysystem = res;
      },
      (error: HttpErrorResponse) => {
        this.handleError(error);
      },
    );
  }

  getCheifComplaintsList() {
    this.dashboardService.getChiefComplaintList().subscribe({
      next: (res: Array<ChiefComplaintList>) => {
        this.chiefComplaintList = res;
        this.otherChiefComplaintField();

        let preselectValue = this.chiefComplaintList.filter(
          (item) => item._id == this.currentVisitDetails.chiefComplaint.id,
        );

        if (preselectValue[0]?.isOther == true) {
          this.form.patchValue({
            otherChiefComplaint: this.currentVisitDetails.chiefComplaint.other,
          });

          this.form.patchValue({
            chiefComplaint: this.currentVisitDetails.chiefComplaint.other,
          });
          if( this.currentVisitDetails.chiefComplaint.other === 'Consulta Mediktor'){
            this.showMediktorSection = true;
          }
        } else {
          this.form.patchValue({
            chiefComplaint: preselectValue[0]?.chiefComplaint.es,
          });
        }
      },
      error: (error: HttpErrorResponse) => {
        this.handleError(error);
      },
    });
  }

  otherChiefComplaintField() {
    var tempOtherChiefComplaint = this.form.get("otherChiefComplaint");
    this.form.get("chiefComplaint").valueChanges.subscribe((val: any) => {
      if (val != null && val != undefined && val != "") {
        if (val.isOther == true) {
          this.showOtherChiefComplaint = true;
          tempOtherChiefComplaint.setValidators([Validators.required]);
          tempOtherChiefComplaint.markAsDirty();
          tempOtherChiefComplaint.markAsTouched();
          tempOtherChiefComplaint.updateValueAndValidity();
        } else {
          this.showOtherChiefComplaint = false;
          tempOtherChiefComplaint.setValue("");
          tempOtherChiefComplaint.clearValidators();
          tempOtherChiefComplaint.updateValueAndValidity();
        }
      } else {
        this.showOtherChiefComplaint = false;
        tempOtherChiefComplaint.setValue("");
        tempOtherChiefComplaint.clearValidators();
        tempOtherChiefComplaint.updateValueAndValidity();
      }
    });
  }

  getUnits() {
    this.dashboardService.getUnits().subscribe({
      next: (res: any) => {
        this.Units = res["data"];
      },
      error: (error: HttpErrorResponse) => {
        this.handleError(error);
      },
    });
  }

  getTablete() {
    this.dashboardService.getTimes().subscribe({
      next: (res: any) => {
        this.tablete = res["data"];
      },
      error: (error: HttpErrorResponse) => {
        this.handleError(error);
      },
    });
  }

  getRouteofAdmininstration() {
    this.dashboardService.getRoute().subscribe({
      next: (res: RouteOfAdministration) => {
        this.adminstrations = res["data"];
      },
      error: (error: HttpErrorResponse) => {
        this.handleError(error);
      },
    });
  }

  getClosureReasons() {
    this.dashboardService.getClosureReasons().subscribe({
      next: (res: any) => {
        this.closureReasons = res;
      },
      error: (error: HttpErrorResponse) => {
        this.handleError(error);
      },
    });
  }

  initReviewOfSystem() {
    return this.fb.group({
      bodySystem: [""],
      value: [""],
    });
  }

  addReviewOfSystem() {
    const control = <FormArray>this.form.controls["reviewOfSystem"];
    control.push(this.initReviewOfSystem());
  }

  removeReviewOfSystem(ir) {
    ((<FormArray>this.form.controls["reviewOfSystem"]) as FormArray).removeAt(
      ir,
    );
  }

  initParaClinicalPrescription() {
    return this.fb.group({
      title: [""],
      description: [""],
    });
  }

  addParaClinicalPrescription() {
    const control = <FormArray>this.form.controls["paraclinicalPrescription"];
    control.push(this.initParaClinicalPrescription());
  }

  removeParaClinicalPrescription(ip) {
    (
      (<FormArray>this.form.controls["paraclinicalPrescription"]) as FormArray
    ).removeAt(ip);
  }

  initX() {
    return this.fb.group({
      //  ---------------------forms fields on x level ------------------------

      name: [""],
      dosage: [{ value: "", disabled: true }],
      unit: [{ value: "", disabled: true }],
      routeOfAdministration: [{ value: "", disabled: true }],
      frequency: [{ value: "", disabled: true }],
      frequencyTime: [{ value: "", disabled: true }],
      duration: [{ value: "", disabled: true }],
      durationTime: [{ value: "", disabled: true }],
      notes: [{ value: "", disabled: true }],
      // ---------------------------------------------------------------------
      alternative: this.fb.array([
        //this.initY()
      ]),
    });
  }

  initY() {
    return this.fb.group({
      //  ---------------------forms fields on y level ------------------------

      name: [""],
      dosage: [{ value: "", disabled: true }],
      unit: [{ value: "", disabled: true }],
      routeOfAdministration: [{ value: "", disabled: true }],
      frequency: [{ value: "", disabled: true }],
      frequencyTime: [{ value: "", disabled: true }],
      duration: [{ value: "", disabled: true }],
      durationTime: [{ value: "", disabled: true }],
      notes: [{ value: "", disabled: true }],
      // ---------------------------------------------------------------------
    });
  }

  addX(forFollowUp: boolean) {
    const control = forFollowUp
      ? <FormArray>this.mpFollowUpForm["controls"].medicalPrescription
      : <FormArray>this.form.controls["medicalPrescription"];
    control.push(this.initX());
  }

  addY(ix, forFollowUp: boolean) {
    const control = (
      forFollowUp
        ? <FormArray>this.mpFollowUpForm["controls"].medicalPrescription
        : <FormArray>this.form.controls["medicalPrescription"]
    )
      .at(ix)
      .get("alternative") as FormArray;
    control.push(this.initY());
  }

  formErrors = {
    medicalPrescription: this.medicalPrescriptionErrors(),
    paraclinicalPrescription: this.paraclinicalPrescriptionErrors(),
    reviewOfSystem: this.reviewOfSystemErrors(),
  };

  reviewOfSystemErrors() {
    return [
      {
        bodySystem: "",
        value: "",
      },
    ];
  }

  paraclinicalPrescriptionErrors() {
    return [
      {
        title: "",
        description: "",
      },
    ];
  }

  medicalPrescriptionErrors() {
    return [
      {
        //  ---------------------forms errors on x level ------------------------
        name: "",
        dosage: "",
        unit: "",
        routeOfAdministration: "",
        frequency: "",
        frequencyTime: "",
        duration: "",
        durationTime: "",
        notes: "",

        // ---------------------------------------------------------------------
        alternative: this.alternativeErrors(),
      },
    ];
  }

  alternativeErrors() {
    return [
      {
        //  ---------------------forms errors on y level ------------------------
        name: "",
        dosage: "",
        unit: "",
        routeOfAdministration: "",
        frequency: "",
        frequencyTime: "",
        duration: "",
        durationTime: "",
        notes: "",
        // ----------------------------------------------------------------------
      },
    ];
  }

  validationMessages = {
    medicalPrescription: {
      name: {
        required: "name is required.",
      },
      dosage: {
        required: "dosage is required.",
      },
      unit: {
        required: "unit is required.",
        pattern: "unit must be 3 characters long.",
      },
      routeOfAdministration: {
        required: "routeOfAdministration is required.",
        pattern: "routeOfAdministration must be 3 characters long.",
      },
      frequency: {
        required: "frequency is required.",
        pattern: "frequency must be 3 characters long.",
      },
      duration: {
        required: "duration is required.",
        pattern: "duration must be 3 characters long.",
      },
      frequencyTime: {
        required: "frequencyTime is required.",
        pattern: "frequencyTime must be 3 characters long.",
      },
      durationTime: {
        required: "durationTime is required.",
        pattern: "durationTime must be 3 characters long.",
      },
      notes: {
        required: "notes is required.",
        pattern: "notes must be 3 characters long.",
      },
      alternative: {
        name: {
          required: "name is required.",
        },
        dosage: {
          required: "dosage is required.",
        },
        unit: {
          required: "unit is required.",
          pattern: "unit must be 3 characters long.",
        },
        routeOfAdministration: {
          required: "routeOfAdministration is required.",
          pattern: "routeOfAdministration must be 3 characters long.",
        },
        frequency: {
          required: "frequency is required.",
          pattern: "frequency must be 3 characters long.",
        },
        duration: {
          required: "duration is required.",
          pattern: "duration must be 3 characters long.",
        },
        frequencyTime: {
          required: "frequencyTime is required.",
          pattern: "frequencyTime must be 3 characters long.",
        },
        durationTime: {
          required: "durationTime is required.",
          pattern: "durationTime must be 3 characters long.",
        },
        notes: {
          required: "notes is required.",
          pattern: "notes must be 3 characters long.",
        },
      },
    },
    paraclinicalPrescription: {
      title: {
        title: "title is required.",
      },
      description: {
        description: "description is required.",
      },
    },
    reviewOfSystem: {
      bodySystem: {
        bodySystem: "bodySystem is required.",
      },
      value: {
        value: "value is required.",
      },
    },
  };

  removeY(ix, iy, forFollowUp) {
    (
      (forFollowUp
        ? <FormArray>this.mpFollowUpForm["controls"].medicalPrescription
        : <FormArray>this.form.controls["medicalPrescription"]
      )
        .at(ix)
        .get("alternative") as FormArray
    ).removeAt(iy);
  }

  removeX(ix, forFollowUp) {
    (
      (forFollowUp
        ? <FormArray>this.mpFollowUpForm["controls"].medicalPrescription
        : <FormArray>this.form.controls["medicalPrescription"]) as FormArray
    ).removeAt(ix);
  }

  public findInvalidControls() {
    const invalid = [];
    const controls = this.form["controls"]["medicalPrescription"]["controls"];
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    return invalid;
  }

  formSubmit() {
    this.form.enable();

    this.setPlan(this.form.get("plan").value ?? "");
    this.setHistoryOfPresentIllness(
      this.form.get("historyOfPresentIllness").value ?? "",
    );

    if (!this.diagnosticListSelected.length) {
      let required = true;

      if (this.haveFollowUp1 || this.haveFollowUp2) {
        required = false;
      }

      this.form.get("diagnosisCie11").setErrors({ required: required });
    }


    if ( this.form.invalid || this.mpFollowUpForm.invalid ) {
      this.translateService
        .get("Please fill the required fields in visit summary form")
        .subscribe((text: string) => {
          this.sharedService.showErrorMessage(text);
        });

      if (this.singPatientRecord?.consultation?.isFollowUp) {
        this.form.disable();
        this.closeAttentionForm.enable();
      }

      this.scrollIntoView.emit("visitSummary");

      return;
    } else {
      // return;
      let ppList = this.form.value["paraclinicalPrescription"];
      for (var f = 0; f < ppList.length ? ppList.length : 0; f++) {
        if (ppList[f].title && !ppList[f].description) {
          this.translateService
            .get("Please enter description in Paraclinical Prescription")
            .subscribe((text: string) => {
              this.sharedService.showErrorMessage(text);
            });
          return;
        } else if (!ppList[f].title && ppList[f].description) {
          this.translateService
            .get("Please enter title in Paraclinical Prescription")
            .subscribe((text: string) => {
              this.sharedService.showErrorMessage(text);
            });
          return;
        }
      }

      let ppp = this.form.value["paraclinicalPrescription"].filter(
        (item) => item.title != "",
      );

      let ros = this.form.value["reviewOfSystem"].filter(
        (item) => item.bodySystem != "",
      );

      let mpl = this.form.value["medicalPrescription"];
      mpl = this.treatMedicalPrescriptions(mpl);

      let data = {
        ...this.form.value,
      };

      const pattern = /^\d{0,3}(\.\d{0,2})?$/;
      if (data.temperature && !pattern.test(data.temperature)) {
        this.translateService
          .get("Enter the valid temperature.")
          .subscribe((text: string) => {
            this.sharedService.showErrorMessage(text);
          });
        return;
      }

      data["paraclinicalPrescription"] = ppp;
      data["reviewOfSystem"] = ros;
      data["medicalPrescription"] = mpl;

      let selectedChiefComplaint = this.chiefComplaintList.find(
        (chiefComplaint) => {
          return (
            this.form.value["chiefComplaint"] ===
            chiefComplaint.chiefComplaint.es
          );
        },
      );

      if (!selectedChiefComplaint) {
        selectedChiefComplaint = this.chiefComplaintList.find(
          (chiefComplaint) => {
            return chiefComplaint.chiefComplaint.es === "Otro";
          },
        );

        data["otherChiefComplaint"] = this.form.value["chiefComplaint"];
      }

      data["chiefComplaint"] = selectedChiefComplaint?._id;

      data["hasFollowUp"] = this.followUpInfo.hasFollowUp;
      data["followUpDate"] = this.followUpInfo.followUpDate;

      let apiData = this.removeEmptyKeys(data);

      if (!this.followCallingUp && apiData.closeAttentionForm?.closeAttention) {
        apiData = {
          ...apiData,
          ...apiData.closeAttentionForm,
        };
      }

      if ( this.singPatientRecord?.consultation?.isFollowUp ) {
        let followUpMpl =
          this.mpFollowUpForm["controls"].medicalPrescription.value;
        followUpMpl = this.treatMedicalPrescriptions(followUpMpl);
        data["medicalPrescription"] = followUpMpl;
        apiData = this.removeEmptyKeys(apiData);
        const formatData = this.formatDataToSend(apiData);
        //console.log(formatData);

        this.dashboardService
          .updateVisitHistory(this.consultId, formatData)
          .subscribe({
            next: (res: any) => {
              this.translateService
                .get("Visit History details updated successfully")
                .subscribe((text: string) => {
                  this.sharedService.showMessage(text, "success");
                });
              this.router.navigate([""]);
            },
            error: (error: HttpErrorResponse) => {
              this.handleError(error);

              if (
                this.isOriginalDoctor &&
                !this.singPatientRecord?.consultation?.isFollowUp
              ) {
                this.form.enable();
                this.isFollowUpEditEnabled = true;
                this.isRegularFormEnabled = true;
              } else {
                this.isFollowUpEditEnabled = true;
                this.isRegularFormEnabled = false;
                this.form.disable();
              }
            },
          });
      } else {
        this.openConfirmEmDialog(
          this.consultId,
          this.formatDataToSend(apiData),
        );
      }
    }

    this.form.disable();
  }

  treatMedicalPrescriptions(mpl) {
    if (mpl.filter((item) => item.name === "" && item.frequency).length > 0) {
      this.translateService
        .get("Medicine name is required")
        .subscribe((text: string) => {
          this.sharedService.showErrorMessage(text);
        });
      return;
    } else {
      mpl = mpl.filter((item) => item.name != "");
      mpl = mpl.map((x) => ({
        ...x,
        frequency: parseInt(x.frequency),
        duration: parseInt(x.duration),
      }));
    }

    for (var i = 0; i < mpl.length; i++) {
      mpl[i] = Object.entries(mpl[i]).reduce(
        (a, [k, v]) => (v ? ((a[k] = v), a) : a),
        {},
      ); //Remove empty values
      let alternative =
        mpl[i].alternative && mpl[i].alternative.length > 0
          ? mpl[i].alternative.filter((item) => item.name != "")
          : [];
      alternative = alternative.map((x) => ({
        ...x,
        frequency: parseInt(x.frequency),
        duration: parseInt(x.duration),
      }));
      alternative = alternative.map((aItem) => {
        aItem = Object.entries(aItem).reduce(
          (a, [k, v]) => (v ? ((a[k] = v), a) : a),
          {},
        ); //Remove empty values
        return aItem;
      });
      if (alternative.filter((item) => item.name === "").length > 0) {
        this.translateService
          .get("Medicine name is required")
          .subscribe((text: string) => {
            this.sharedService.showErrorMessage(text);
          });
        return;
      } else {
        mpl[i].alternative = alternative;
      }
    }

    return mpl;
  }

  removeEmptyKeys(obj) {
    for (var propName in obj) {
      if (
        obj[propName] === null ||
        obj[propName] === undefined ||
        obj[propName] === "" ||
        obj[propName].length < 1
      ) {
        delete obj[propName];
      }
    }
    return obj;
  }

  _keyPress(event: any) {
    const pattern = /^\d{0,3}(\.\d{0,2})?$/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  testCalling(data: boolean) {
    this.isTestCall = data;
    if (data === true) {
      this.form.disable();
    } else {
      this.form.enable();
    }
  }

  handleError(error) {
    let errorMessage = "";
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = error.error.message;
      this.sharedService.showErrorMessage(errorMessage, "single");
    } else {
      // server-side error
      if (error.status == 422) {
        let values = [];
        const messages = error.error.errors.messages;
        for (let key in messages) {
          Object.keys(messages[key]).forEach((errorKey) => {
            values.push(messages[key][errorKey]);
          });
        }
        this.sharedService.showMultipleErrors(values, "multi");
      } else {
        //console.log(error);
        if (typeof error.error.errors == "object") {
          errorMessage = error.error.errors.messages[0];
        } else {
          errorMessage =
            error?.error?.errors || error?.error?.message.join(", ");
        }
        this.sharedService.showErrorMessage(errorMessage, "single");
      }
    }
  }

  documentsGetImage(data: any) {
    try {
      const bucketName = "sinapsis-dev.s3.us-east-1";

      if (!data.url.split(".com")[0].includes(bucketName)) {
        data.url =
          "https://sinapsis-dev.s3.us-east-1.amazonaws.com/" + data.url;
      }

      var url = new URL(data.url);
      var path = url.pathname;

      const imageExtension = path.split(".").pop().toLowerCase();

      const extDict = {
        png: "png",
        jpg: "jpg",
        jpeg: "jpg",
        pdf: "pdf",
        docx: "doc",
        doc: "doc",
        xls: "xls",
        xlsx: "xls",
        csv: "xls",
      };

      return extDict[imageExtension] || "png";
    } catch (error) {
      console.error("Error parsing URL:", error);
    }
  }

  attachmentPopup(attachment) {
    const dialogRef = this.dialog.open(AttachmentPopupComponent, {
      width: "600px",
      panelClass: "attachment-popup-dialog",
      data: { document: attachment._id, status: false },
    });
    dialogRef.afterClosed().subscribe((result) => {});
  }

  enableUpdateBtn() {
    this.historyOfPresentIllness = this.form.get(
      "historyOfPresentIllness",
    ).value;
    this.paraclinics = this.form.get("paraclinics").value;
    this.differentialDiagnosisCie11 = this.form.get(
      "differentialDiagnosisCie11",
    ).value;
    this.diagnosisCie11 = this.form.get("diagnosisCie11").value;
    this.plan = this.form.get("plan").value;
    this.doctorNotes = this.form.get("doctorNotes").value;

    this.followUpCall.subjective =
      this.form.controls["followUpForm"].get("subjective").value;
    this.followUpCall.objective =
      this.form.controls["followUpForm"].get("objective").value;
    this.followUpCall.assesment =
      this.form.controls["followUpForm"].get("assesment").value;
    this.followUpCall.plan =
      this.form.controls["followUpForm"].get("plan").value;



    if (
      this.isOriginalDoctor &&
      !this.singPatientRecord?.consultation?.isFollowUp
    ) {
      this.form.enable();
      this.isFollowUpEditEnabled = true;
      this.isRegularFormEnabled = true;
    } else {
      this.form.disable();
      this.isFollowUpEditEnabled = true;
      this.isRegularFormEnabled = false;
    }
    this.closeAttentionForm.enable();
  }

  getErrorMessage(formControl) {
    return "Campo requerido";
  }

  closeAttentionChange(event) {
    const closureReasonControl = this.closeAttentionForm.get("closureReason");
    closureReasonControl.reset();
    closureReasonControl.setValidators([]);
    closureReasonControl.updateValueAndValidity();

    const otherClosureReasonControl =
      this.closeAttentionForm.get("otherClosureReason");
    otherClosureReasonControl.reset();
    otherClosureReasonControl.setValidators([]);
    otherClosureReasonControl.updateValueAndValidity();

    if (event && event.checked) {
      closureReasonControl.setValidators([Validators.required]);
      closureReasonControl.updateValueAndValidity();

      this.isOtherClosureReason = false;
    }
  }

  closureReasonChange(event) {
    if (event && event.value) {
      const closureReason = this.closureReasons.find((closureReason) => {
        return closureReason._id === event.value;
      });

      this.isOtherClosureReason = closureReason && closureReason.isOther;
    } else {
      this.isOtherClosureReason = false;
    }

    const otherClosureReasonControl =
      this.closeAttentionForm.get("otherClosureReason");
    otherClosureReasonControl.reset();

    if (this.isOtherClosureReason) {
      otherClosureReasonControl.setValidators([Validators.required]);
      otherClosureReasonControl.updateValueAndValidity();
    } else {
      otherClosureReasonControl.setValidators([]);
      otherClosureReasonControl.updateValueAndValidity();
    }
  }

  formatDataToSend(data: any) {
    return {
      ...data,
      mediktorPrediagnosticMatching:  this.compatibleDiagnosticMediktor,
      diagnosisCie11: this.diagnosticListSelected.map(
        (diagnosis) => diagnosis._id,
      ),
      differentialDiagnosisCie11: this.differentialDiagnosisListSelected.map(
        (diagnosis) => diagnosis._id,
      ),
      followUpForm: {
        subjective: data.followUpForm.subjective,
        objective: data.followUpForm.objective,
        assesmentCie11:
          this.assessmentListSelected.length > 0
            ? this.assessmentListSelected.map((diagnosis) => diagnosis._id)
            : [],
        plan: data.followUpForm.plan,
      },
    };
  }

  onChangeDifferentDiagnosisCie11(event) {
    if (event.length > 2) {
      const selectedDiagnosisSet = new Set(
        this.differentialDiagnosisListSelected.map((diag) => diag._id),
      );
      this.dashboardService.getDiagnosticList(event).subscribe({
        next: (res: any) => {
          this.differentialDiagnosisListFiltered = res.data.filter(
            (diagnosis) => {
              return !selectedDiagnosisSet.has(diagnosis._id);
            },
          );
        },
        error: (error: HttpErrorResponse) => {
          this.handleError(error);
        },
      });
    }
  }

  onChangeDiagnosisCie11(event) {
    if (event.length > 2) {
      const selectedDiagnosisSet = new Set(
        this.diagnosticListSelected.map((diag) => diag._id),
      );
      this.dashboardService.getDiagnosticList(event).subscribe({
        next: (res: any) => {
          this.diagnosticListFiltered = res.data.filter((diagnosis) => {
            return !selectedDiagnosisSet.has(diagnosis._id);
          });
        },
        error: (error: HttpErrorResponse) => {
          this.handleError(error);
        },
      });
    }
  }

  addDiagnosis(diagnosis: any, diagnosisArray: any[], control: string) {
    diagnosisArray.push(diagnosis);
    this.diagnosticListFiltered = [];
    this.differentialDiagnosisListFiltered = [];
    this.form.get(control).setValue("", { emitEvent: false });
  }

  removeDiagnosis(diagnosisId: string) {
    this.diagnosticListSelected = this.diagnosticListSelected.filter(
      (diagnosis) => diagnosis._id != diagnosisId,
    );
    if (this.diagnosticListSelected.length === 0) {
      this.form.get("diagnosisCie11").setErrors({ required: true });
    }
  }
  removeDiffDiagnosis(diagnosisId: string) {
    this.differentialDiagnosisListSelected =
      this.differentialDiagnosisListSelected.filter(
        (diagnosis) => diagnosis._id != diagnosisId,
      );
  }

  transformTitle(title: string) {
    if (title.length > 150) {
      return title.substring(0, 150) + "...";
    } else {
      return title;
    }
  }
  //// assessment
  onChange(event) {
    if (event.length > 2) {
      const selectedDiagnosisSet = new Set(
        this.assessmentListSelected.map((diag) => diag._id),
      );
      this.dashboardService.getDiagnosticList(event).subscribe({
        next: (res: any) => {
          this.assessmentListFiltered = res.data.filter((diagnosis) => {
            return !selectedDiagnosisSet.has(diagnosis._id);
          });
        },
        error: (error: HttpErrorResponse) => {
          this.handleError(error);
        },
      });
    }
  }
  addAssessment(diagnosis: any, diagnosisArray: any[]) {
    diagnosisArray.push(diagnosis);
    this.assessmentListFiltered = [];
    const input = document.getElementById("assessmentID") as HTMLInputElement;
    if (input) {
      input.value = "";
    }
  }
  removeAssessment(diagnosisId: string) {
    this.assessmentListSelected = this.assessmentListSelected.filter(
      (diagnosis) => diagnosis._id != diagnosisId,
    );
  }

  ////
  getSpecialtyName(consultation: any) {
    if (consultation.appointmentType === 2) {
      if (consultation.medicalSpecialty?.subSpeciality) {
        return `Triaje para ${
          consultation.medicalSpecialty.subSpeciality.subSpeciality[
            this.currentLanguage
          ]
        } - 
      ${
        consultation.chiefComplaint.other
          ? consultation.chiefComplaint.other
          : consultation.chiefComplaint.chiefComplaint[this.currentLanguage]
      }`;
      }
      if (consultation.medicalSpecialty?.speciality) {
        return `Triaje para ${
          consultation.medicalSpecialty.speciality.speciality[
            this.currentLanguage
          ]
        } - 
        ${
          consultation.chiefComplaint.other
            ? consultation.chiefComplaint.other
            : consultation.chiefComplaint.chiefComplaint[this.currentLanguage]
        }`;
      }
    }

    return "";
  }

  openConfirmEmDialog(consultId: any, formData: any) {
    console.log({transfer: this.transfer});
    if ( this.normalConsult ) {
      this.justSave(consultId, formData);
    } 
    else {
      if ( this.transfer ) {
        const transferData = {
          title: "¿Estás seguro que deseas transferir al agente?",
          acceptAction: "Si",
          cancelAction: "No",
          margin: false,
        };
        this.confirmDialog(consultId, formData, transferData);
      } 
      else {
        const saveAndExitData = {
        title: "Verifica si deseas transferir al agente",
        acceptAction: "Transferir",
        cancelAction: "Guardar y salir",
        margin: true,
      };
        this.confirmDialog(consultId, formData, saveAndExitData);
      }
    }
  }

  confirmDialog(consultId: any, formData: any, data: any) {
    if ( this.dialogRef ) {
      this.dialogRef.close();
    }
    this.dialogRef = this.dialog.open(ConfirmEmConsultationComponent, {
      width: "600px",
      height: "380px",
      data: data,
      panelClass: "transfer-dialog",
      disableClose: true,
      autoFocus: false,
    });
    this.dialogRef.afterClosed().subscribe((result) => {
      this.dialogRef = null;
      console.log({result});
      if ( result === true ) {
        this.saveAndTransfer(consultId, formData);
      } 
      else if ( result === false ) {
        this.justSave(consultId, formData);
      } else if ( result === "close" ) {
        // Stay on current route, don't navigate to home
      }
    });
  }

  saveAndTransfer(consultId: any, formData: any) {
    this.dashboardService.createVisitSummary(consultId, formData).subscribe({
      next: () => {
        this.dashboardService.transferConsultToAgent(this.consultId).subscribe({
          next: (res: any) => {
            this.clevertap.registerEvent$("agent_queue_request", {
              user_id: res.data.patientIdentificationNumber,
              specialty: res.data.medicalSpecialty,
            });
            this.sharedService.showMessage(
              "Paciente enviado a la sala del agente",
              "success",
            );
            this.router.navigate([""]);
          },
          error: (error: HttpErrorResponse) => {
            this.handleError(error);
          },
        });
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  justSave(consultId: any, formData: any) {
    this.dashboardService.createVisitSummary(consultId, formData)
    .subscribe({
      next: () => {
        this.translateService
          .get("Visit History details created successfully")
          .subscribe((text: string) => {
            this.sharedService.showMessage(text, "success");
          });
        this.router.navigate([""]);
      },
      error: (error: HttpErrorResponse) => {
        this.handleError(error);
      },
    });
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
